"use client";

export { Button, buttonVariants } from "@repo/ui/button";
export type { ButtonProps } from "@repo/ui/button";
